import React from 'react';

// Concentric cyan rings + red radius line + orbiting red dot + white centre.
// Compact SVG mark used in the header wordmark and footer brand block.
export const RadiusMark = ({ size = 36, className = '' }) => {
  const s = size;
  const cx = s / 2;
  const cy = s / 2;
  return (
    <svg
      width={s}
      height={s}
      viewBox={`0 0 ${s} ${s}`}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="rmDot" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#fff" stopOpacity="1" />
          <stop offset="45%" stopColor="#EF4444" stopOpacity="1" />
          <stop offset="100%" stopColor="#EF4444" stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx={cx} cy={cy} r={s * 0.44} fill="none" stroke="#0FF0FC" strokeOpacity="0.55" strokeWidth="1" />
      <circle cx={cx} cy={cy} r={s * 0.30} fill="none" stroke="#0FF0FC" strokeOpacity="0.85" strokeWidth="1" />
      <circle cx={cx} cy={cy} r={s * 0.18} fill="none" stroke="#0FF0FC" strokeOpacity="1" strokeWidth="1" />
      <line x1={cx} y1={cy} x2={cx + s * 0.30} y2={cy} stroke="#EF4444" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx={cx + s * 0.30} cy={cy} r={s * 0.09} fill="url(#rmDot)" />
      <circle cx={cx} cy={cy} r={s * 0.055} fill="#F9FAFB" />
    </svg>
  );
};

export default RadiusMark;
